import CustomCheckBox from "@/components/CustomCheckBox/CustomCheckBox.vue"
import UrlBlock from "@/components/UrlBlock/UrlBlock.vue"
import AccordionSocialRow from "@/components/AccordionSocialRow/AccordionSocialRow.vue"
import draggable from "vuedraggable"

export default {
    name: "AccordionSocial",
    props: ["old", "startSteps", "blocking", "isUpdate"],
    components: {
        CustomCheckBox,
        UrlBlock,
        AccordionSocialRow,
        draggable
    },
    data() {
        return {
            networks: this.$props.old,
            dragging: false,
            last: this.$props.old.length,
            test: 0,
        }
    },
    created() {
    },
    methods: {
        update_statuses(acc) {
            this.$emit('update_up', acc)
        },
        contains(elem, arr) {
            let last
            for (var i = 0; i < arr.length; i++) {
                if (arr[i] === elem) {
                    return false;
                }
            }
            return true;

        },
        onEnd(event) {
            this.isDragging = false;
            this.test = event.newIndex;
            let oldIndex = event.oldIndex;
            let newIndex = event.newIndex;
            let selected = this.selectedGates();
            if (oldIndex > 0) {
                this.constructSwitch(selected, newIndex, oldIndex);
            } else {
                this.constructSwitch(selected, oldIndex, newIndex);
            }
            this.list.map((item, key) => {
                item.sort = key;
                if (item.sub_id === this.list[newIndex].sub_id) {
                    this.list[newIndex].sort = newIndex
                }
            });
            this.updateSortSteps()
        },
        updateSortForOneStep(payload) {
            // console.log(payload);
            this.list.map((item, key) => {
                item.sort = key;
            });
            this.updateSortSteps()
        },
        updateSortSteps() {
            this.$emit('updateSortSteps', this.list);
        },
        onStartDragging(event) {
            this.isDragging = true;
        },
        updateTypeOnDrag() {

        },
        selectedGates() {
            let active = this.list.filter(item => item.status === true);
            return active;
        },
        constructSwitch(arrGates, indexMain, indexExtra) {
            if (this.list[indexExtra].check.type === 'Or') {
                if (indexExtra === (arrGates.length - 1) || this.list[indexMain].check.type === 'And') {
                    this.list[indexExtra].check.type = 'And';
                }
                this.list[indexMain].check.type = 'Or';
            }
            else if (this.list[indexExtra].check.type === 'And') {
                // console.log(this.list[indexMain].check.type);
                // console.log(indexExtra);
                if (indexExtra === (arrGates.length - 1) && this.list[indexMain].check.type === 'Or') {
                    this.list[indexExtra].check.type = 'Or';
                }
                this.list[indexMain].check.type = 'And';
            }
        }
    },
    computed: {
        dragOptions() {
            return {
                animation: 0,
                group: "name",
                disabled: false,
                ghostClass: "ghost"
            };
        },
        list: {

            get: function () {
                let lastActiveItemId = 0
                let arrActiveItems = []
                this.networks.map(item => {
                    if ((item.check.inputs.length > 0 && item.icon !== 'messenger') || (item.status && item.check.fillable === false)) {
                        lastActiveItemId = item.sub_id
                        arrActiveItems.push(item)
                    }
                })
                this.networks.forEach(item => {
                    let checkItem = this.contains(item, arrActiveItems)
                    if (checkItem) {
                        arrActiveItems.push(item)
                    }
                })
                this.last = lastActiveItemId
                this.networks = arrActiveItems
                this.$emit('steps', this.networks)
                return this.networks
            },
            set: function (newValue) {
                this.networks = newValue
                localStorage.newPageSteps = JSON.stringify(this.networks)
            }

        }


    },
}
